<!--
  A fila dos comprovantes de PIX/transferência da taxa de implantação que esperam a conferência
  do Full, de todas as franquias (chamado New Shoes 2026-0079, F3). Some quando está vazia.
-->
<template>
  <section v-if="fila.length" class="fila" data-testid="setup-comprovantes-fila">
    <h3>{{ t('Comprovantes para conferir') }} <span class="contador">{{ fila.length }}</span></h3>
    <conferencia-do-comprovante v-for="c in fila" :key="c.id" :comprovante="c" mostrar-franquia />
  </section>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import ConferenciaDoComprovante from './ConferenciaDoComprovante.vue';
import { useSetupComprovantes, mensagemDoComprovante } from '../../composables/useSetupComprovantes';
import { eventBus } from '../../eventBus';

const { t } = useI18n();
const { fila, carregarFila } = useSetupComprovantes();

onMounted(() => {
  carregarFila().catch((e: unknown) => eventBus.emit('globalMessage.error', t(mensagemDoComprovante(e))));
});
</script>

<style scoped>
.fila { display: flex; flex-direction: column; gap: 10px; background: var(--p-content-background, #fff); border-radius: 12px; padding: 16px 20px; }
.fila h3 { margin: 0; font-size: 17px; font-weight: 800; display: flex; align-items: center; gap: 8px; }
.contador { padding: 2px 9px; border-radius: 999px; background: #e0e9fb; color: #1a3e9e; font-size: 13px; }
</style>
